(function ($, Promise) {

	// Setup the prototype inheritance
	extend(BaseGame, Enigma);

	// Constructor
	function Enigma() {

		// Super constructor
		BaseGame.call(this);
		this.resetDelay = 60 * 1000;
		// this.resetDelay = -1;

		// Override toolbar screen since we have a screensaver
		// this.activateToolbarFrom = 2;

		// Variable to hold data
		this.data = {}

		// Enigma simulator
		this.enigma = false;
		this.enigmaMessage = "";
		this.lastLetterSteps = false;
		this.pressedKey = false;
		this.animationComplete = true;

		// Animations and timelines
		this.letterOdysseyTimeline = false;

		// Load data then init
		this.loadData();

		// Bind TAB key to toggle guides
		$(window).bind("keydown", $.proxy(function (e) {
			if (e.keyCode == 9) {
				e.preventDefault();
				$("#guide, .guide").toggle();
			}
		}, this));

		// Resize window
		var isNWJS = (typeof nw != "undefined") ? true : false;
		if (isNWJS) {
			var gui = require("nw.gui")
			gui.Window.get().width = 1080;
			gui.Window.get().height = 1920;
		}
	}

	Enigma.prototype.loadData = function () {

		// Load JSON for ZONES
		var json1 = $.ajax({
			url: "data/enigma.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data = JSON.parse(data.responseText);
			}, this)
		});

		// Require Enigma simulator modules
		var requires = new Promise(function (resolve, reject) {
			requirejs(["js/libs/enigma/EnigmaTables.js"], function () {
				requirejs(["js/libs/enigma/EnigmaSimulator.js"], resolve, reject);
			}, reject)
		});

		// Wait for all
		Promise.all([
			json1.promise(),
			requires,
		]).then($.proxy(function () {
			this.initGame();
		}, this));

	};

	Enigma.prototype.initGame = function () {

		// Load SVGs
		convertSVGToInline();

		// Start serial server
		this.serial = new Serial("data/enigma.json")

		// Go to first element
		this.goToScreen(1);

		// Init rotors
		this.rotor1 = new EnigmaRotor($("#rotor-1"), wheel1);
		this.rotor2 = new EnigmaRotor($("#rotor-2"), wheel2);
		this.rotor3 = new EnigmaRotor($("#rotor-3"), wheel3);

		// Init enigma simulator
		this.startEnigma();

		// Bind keydown events
		$(window).on("keydown", $.proxy(function (e) {
			if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 97 && e.keyCode <= 122)) {
				var letter = e.key.toLowerCase();
				if (this.pressedKey == false) {
					this.typeIn(letter);
					this.pressedKey = letter;
				}
			} else if (e.keyCode == 32) {
				this.startEnigma();
				this.pressedKey = false;
			}
			this.resetTimer();
		}, this)).bind("keyup", $.proxy(function (e) {
			var letter = e.key.toLowerCase();
			if (this.pressedKey == letter) {
				this.undoLastLetter();
				this.pressedKey = false;
			}
			this.resetTimer();
		}, this));

		// Bind serial events
		if (this.serial) {
			this.serial.on("action", $.proxy(function (e) {
				console.log(e.actionId, e.actionValue);
				if (e.actionId.substring(0, 3) == "key") {
					if (e.actionValue == "_PRESS") {
						var letter = e.actionId.substring(4, 5);
						if (this.pressedKey == false) {
							this.typeIn(letter);
							this.pressedKey = letter;
						}
					} else if (e.actionValue == "_RELEASE") {
						var letter = e.actionId.substring(4, 5);
						if (this.pressedKey == letter) {
							this.undoLastLetter();
							this.pressedKey = false;
						}
					}
				} else if (e.actionId == "reset" && e.actionValue == "_PRESS") {
					this.startEnigma();
					this.pressedKey = false;
				}
				this.resetTimer();
			}, this));
		}

		// Bind virtual keydown events
		$(".keyboard-key").on("click", $.proxy(function (e) {
			var letter = $(e.currentTarget).data("key");
			this.typeIn(letter);
		}, this));

		// this.typeIn("x")

	};

	Enigma.prototype.goToScreen = function (screenId, callback) {

		// Super constructor
		BaseGame.prototype.goToScreen.call(this, screenId, callback);

		if (screenId == 2) {
			// this.requestHighlightTimer(8000);
		}

	}

	Enigma.prototype.typeIn = function (letter) {

		if (this.enigmaMessage.length >= 10) {
			return;
		}

		// Set enigma to encrypt mode
		this.enigma.settings.mode = this.enigma.ENIGMA_MODE_ENCRYPT;

		// Add new letter to enigma message
		this.enigmaMessage = this.enigmaMessage + letter;
		this.enigma.settings.message = this.enigmaMessage;

		// Process enigma
		var enigmaResult = this.enigma.process();
		console.log(enigmaResult);

		// Get last letter steps
		this.lastLetterSteps = enigmaResult.process[enigmaResult.process.length - 1].steps

		// Process letter odyssey
		this.letterOdysseyAnimation(this.lastLetterSteps, enigmaResult.input, enigmaResult.result);

	}

	Enigma.prototype.letterOdysseyAnimation = function (steps, enigmaInput, enigmaOutput) {

		this.animationComplete = false;

		// Define letter custom path
		this.letterOdysseyPathPart1(steps, $("#template-1, #path-1"));
		this.letterOdysseyPathPart2(steps, $("#template-2, #path-2"));
		this.letterOdysseyPathPart3(steps, $("#template-3, #path-3"));

		// Increase this value for a longer animation
		var duration = 2;

		// Values used
		var red = "#dc5033";
		var path1 = MorphSVGPlugin.pathDataToBezier("#path-1");
		var path2 = MorphSVGPlugin.pathDataToBezier("#path-2");
		var path3 = MorphSVGPlugin.pathDataToBezier("#path-3");

		// Stop current animation
		this.stopCurrentAnimation();

		// Create timeline object
		this.letterOdysseyTimeline = new TimelineMax();

		// Update text box
		this.letterOdysseyTimeline.set("#input-box span", {innerHTML: enigmaInput});

		// Path template
		this.letterOdysseyTimeline.to($(".path-template"), (0.2 * duration), {opacity: 1, ease: Linear.easeInOut});

		// Keyboard
		this.letterOdysseyTimeline.add($.proxy(this.updateElectronLetter, this, steps[0].result), 0);
		this.letterOdysseyTimeline.fromTo($("#keyboard-key-" + steps[0].result + " span"), 0.5, {backgroundColor: "white"}, {backgroundColor: red}, 0);
		this.letterOdysseyTimeline.add(function () {
			$("#keyboard-key-" + steps[0].result).addClass("pressed");
		}, 0);


		// Rotors rotate
		if (steps[2].increase) {
			this.letterOdysseyTimeline.add($.proxy(this.rotor1.tick, this.rotor1), 0);
			// this.rotor1.tick();
		}
		if (steps[3].increase) {
			this.letterOdysseyTimeline.add($.proxy(this.rotor2.tick, this.rotor2), 0);
			// this.rotor2.tick();
		}
		if (steps[4].increase) {
			this.letterOdysseyTimeline.add($.proxy(this.rotor3.tick, this.rotor3), 0);
			// this.rotor3.tick();
		}

		// Odyssey part 1 (from keyboard to plugboard)
		this.letterOdysseyTimeline.set("#electron", {x: path1[0].x, y: path1[0].y, opacity: 1}, 0.1);
		this.letterOdysseyTimeline.fromTo("#path-1", (0.4 * duration), {drawSVG: "0%", opacity: 1}, {drawSVG: "100%", ease: Linear.easeInOut}, 0.1);
		this.letterOdysseyTimeline.to("#electron", (0.4 * duration), {bezier: {values: path1, type: "thru"}, ease: Linear.easeInOut}, 0.1);

		// Odyssey part 2 (from plugboard to reflector)
		this.letterOdysseyTimeline.set("#electron", {x: path2[0].x, y: path2[0].y}, "+=0.1");
		this.letterOdysseyTimeline.add($.proxy(this.updateElectronLetter, this, steps[1].result));
		this.letterOdysseyTimeline.fromTo("#path-2", (2 * duration), {drawSVG: "0%", opacity: 1}, {drawSVG: "100%", ease: Linear.easeInOut});
		this.letterOdysseyTimeline.to("#electron", (2 * duration), {bezier: {values: path2, type: "thru"}, ease: Linear.easeInOut}, "-=" + (2 * duration));
		this.letterOdysseyTimeline.add($.proxy(this.updateElectronLetter, this, steps[2].result, this.rotor1), "-=" + (0.515 * duration));
		this.letterOdysseyTimeline.add($.proxy(this.updateElectronLetter, this, steps[3].result, this.rotor2), "-=" + (0.35 * duration));
		this.letterOdysseyTimeline.add($.proxy(this.updateElectronLetter, this, steps[4].result, this.rotor3), "-=" + (0.2 * duration));

		// Odyssey part 2 (from reflector to lightboard)
		this.letterOdysseyTimeline.set("#electron", {x: path3[0].x, y: path3[0].y});
		this.letterOdysseyTimeline.add($.proxy(this.updateElectronLetter, this, steps[5].result));
		this.letterOdysseyTimeline.fromTo("#path-3", (3 * duration), {drawSVG: "0%", opacity: 1}, {drawSVG: "100%", ease: Linear.easeInOut});
		this.letterOdysseyTimeline.to("#electron", (3 * duration), {bezier: {values: path3, type: "thru"}, ease: Linear.easeInOut}, "-=" + (3 * duration));
		this.letterOdysseyTimeline.add($.proxy(this.updateElectronLetter, this, steps[6].result, this.rotor3), "-=" + (2.82 * duration));
		this.letterOdysseyTimeline.add($.proxy(this.updateElectronLetter, this, steps[7].result, this.rotor2), "-=" + (2.64 * duration));
		this.letterOdysseyTimeline.add($.proxy(this.updateElectronLetter, this, steps[8].result, this.rotor1), "-=" + (2.50 * duration));
		this.letterOdysseyTimeline.add($.proxy(this.updateElectronLetter, this, steps[9].result), "-=" + (1.08 * duration));

		// Update text box
		this.letterOdysseyTimeline.set("#output-box span", {innerHTML: enigmaOutput});

		this.letterOdysseyTimeline.set(this, {animationComplete: true});

		// Lightboard
		this.letterOdysseyTimeline.fromTo($("#lightboard-key-" + steps[10].result + " span"), 0.5, {backgroundColor: "black"}, {backgroundColor: red});

		// Out
		this.letterOdysseyTimeline.to(["#path-1", "#path-2", "#path-3"], 1, {opacity: 0, ease: Linear.easeInOut});
		this.letterOdysseyTimeline.to($("#keyboard-key-" + steps[0].result + " span"), 0.5, {backgroundColor: "white"});
		this.letterOdysseyTimeline.add(function () {
			$("#keyboard-key-" + steps[0].result).removeClass("pressed");
		}, "-=0.5");
		this.letterOdysseyTimeline.to($("#lightboard-key-" + steps[10].result + " span"), 0.5, {backgroundColor: "black"}, "-=0.5");
		this.letterOdysseyTimeline.to($(".path-template"), (0.2 * duration), {opacity: 0, ease: Linear.easeInOut}, "-=0.5");
	}

	Enigma.prototype.letterOdysseyPathPart1 = function (steps, $paths) {

		var d = ""
		var initialLetter = $("#keyboard-key-" + steps[0].result);

		// Start position
		d += "M" + (initialLetter.offset().left + initialLetter.width() / 2) + "," + 1300 + '\n';

		//Line down
		d += 'l0,40\n';

		// Exception fo T and V letters
		if (steps[0].result != "t" && steps[0].result != "v") {

			// Curve to horizontal
			if (initialLetter.offset().left < 490) {
				d += 'q0,15,15,15' + '\n';
			} else {
				d += 'q0,15,-15,15' + '\n';
			}

			// Line to center
			d += 'L490,1354\n';

			// Curve down
			if (initialLetter.offset().left < 490) {
				d += 'q15,0,15,15' + '\n';
			} else {
				d += 'q-15,0,-15,15' + '\n';
			}
		} else {
			// Go lower for T and V keys
			d += 'l0,40\n';
		}


		// Line to plugboard
		d += 'l0,40\n';

		$paths.attr("d", d);
	}

	Enigma.prototype.letterOdysseyPathPart2 = function (steps, $paths) {

		var d = ""

		// Move out of plugboard
		d += 'M927,1538\n';
		d += 'q60,0,60,-60' + '\n';

		// Line to rotors
		d += 'l0,-810\n'

		// Curve to rotors
		d += 'q0,-60,-60,-60' + '\n';

		// Line to reflector
		d += 'l-740,0' + '\n';

		$paths.attr("d", d);
	}

	Enigma.prototype.letterOdysseyPathPart3 = function (steps, $paths) {

		var d = ""

		// Start position
		d += 'M188,607\n';

		// Line through rotors
		d += 'l738,0\n';

		// Curve out of rotors
		d += 'q60,0,60,60' + '\n';

		// Line to plugobard
		d += 'l0,811\n'

		// Curve in to plugboard
		d += 'q0,60,-60,60' + '\n';

		// Move out of plugboard
		d += 'L738,1373\n';
		d += 'l0,-2\n';
		d += 'q0,-15,15,-15' + '\n';
		d += 'l170,0\n';

		// Curve up
		d += 'q30,0,30,-30' + '\n';

		// Lin up to lighboard
		d += 'l0,-430' + '\n';

		// Curve into lightboard
		d += 'q0,-30,-30,-30' + '\n';
		d += 'l-40,0' + '\n';

		$paths.attr("d", d);
	}

	Enigma.prototype.updateElectronLetter = function (letter, rotor) {
		$("#electron span").text(letter);

		if (rotor) {
			// rotor.tick();
		}
	}

	Enigma.prototype.startEnigma = function () {

		// Stop current animation
		if (this.letterOdysseyTimeline) {
			this.letterOdysseyTimeline.progress(1).kill();
			this.letterOdysseyTimeline = false;
		}

		// Restart a new Enigma simulator
		this.enigmaMessage = "";
		$("#input-box span").text("")
		$("#output-box span").text("")

		// Reset rotors
		this.rotor1.reset();
		this.rotor2.reset();
		this.rotor3.reset();

		// Original Cypher 2 example
		// var enigmaSettingsEncode = {
		// uppercase: 1,
		// mode: EnigmaSimulator.ENIGMA_MODE_ENCRYPT,
		// // digraphic: 0,
		// printeachstep: true,
		// ukw: "B",
		// // ukwt: 1,
		// wheelorder: "123",
		// rings: "AAA",
		// wheelstarts: "AAA",
		// message: "ENIGMADECODED",
		// stecker: "ATBLDFGJHMNWOPQYRZVX",
		// debug: false,
		// };

		this.pressedKey = false;
		this.lastLetterSteps = false;
		this.animationComplete = true;

		// Init enigma simulator
		this.enigma = new EnigmaSimulator({
			uppercase: false,
			digraphic: false,
			ukw: "B",
			// ukwt: 1,
			wheelorder: "123",
			rings: "AAA",
			wheelstarts: "AAA",
			message: "",
			stecker: "ATBLDFGJHMNWOPQYRZVX",
			debug: false,
			// printeachstep: true,
		});

	}

	Enigma.prototype.stopCurrentAnimation = function () {

		// Stop current animation
		if (this.letterOdysseyTimeline) {
			this.letterOdysseyTimeline.progress(1).kill();
			this.letterOdysseyTimeline = false;
		}
	}

	Enigma.prototype.undoLastLetter = function () {

		// Do not procced if animation is already completed
		if (this.animationComplete == true) {
			this.stopCurrentAnimation();
			return;
		}

		this.stopCurrentAnimation();

		// Add new letter to enigma message
		this.enigmaMessage = this.enigmaMessage.slice(0, -1);
		$("#input-box span").text(this.enigmaMessage);
		$("#output-box span").text($("#output-box span").text().slice(0, -1));

		// Rotors rotate
		if (this.lastLetterSteps) {
			if (this.lastLetterSteps[2].increase) {
				this.rotor1.untick();
			}
			if (this.lastLetterSteps[3].increase) {
				this.rotor2.untick();
			}
			if (this.lastLetterSteps[4].increase) {
				this.rotor3.untick();
			}
		}
	}


	Enigma.prototype.goToHome = function () {
		this.reset(1)
	}

	Enigma.prototype.goToScrenSaver = function () {

		// Super constructor
		// var shouldReset = BaseGame.prototype.shouldReset.call(this);

		// if (shouldReset) {
		// 	this.reset(2);
		// }

		this.reset(false)
	}

	Enigma.prototype.reset = function (destinationScreen) {

		// Stop current animation
		this.stopCurrentAnimation();

		// Resart enigma
		this.startEnigma();

		// Next block only if a desitnationScreen is not false
		if (destinationScreen !== false) {

			// Define destination screen
			destinationScreen = destinationScreen || 1;

			// Go to screen
			this.goToScreen(destinationScreen);
		}
	}

	// Expose Timeline
	window.Enigma = Enigma;

})
(jQuery, Promise);